
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
} = require('./runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.16.2
 * Query Engine version: 4bc8b6e1b66cb932731fb1bdbbc550d1e010de81
 */
Prisma.prismaVersion = {
  client: "4.16.2",
  engine: "4bc8b6e1b66cb932731fb1bdbbc550d1e010de81"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ChainflexSeriesScalarFieldEnum = {
  echainId: 'echainId',
  akeneoCode: 'akeneoCode',
  dataSource: 'dataSource',
  description: 'description',
  categories: 'categories',
  mainCategory: 'mainCategory',
  unsupportedAllowed: 'unsupportedAllowed',
  speedMaxUnsupported: 'speedMaxUnsupported',
  speedMaxUnsupportedUnit: 'speedMaxUnsupportedUnit',
  accelerationMaxUnsupported: 'accelerationMaxUnsupported',
  accelerationMaxUnsupportedUnit: 'accelerationMaxUnsupportedUnit',
  travelDistanceUnsupported: 'travelDistanceUnsupported',
  travelDistanceUnsupportedUnit: 'travelDistanceUnsupportedUnit',
  glidingAllowed: 'glidingAllowed',
  speedMaxGliding: 'speedMaxGliding',
  speedMaxGlidingUnit: 'speedMaxGlidingUnit',
  accelerationMaxGliding: 'accelerationMaxGliding',
  accelerationMaxGlidingUnit: 'accelerationMaxGlidingUnit',
  travelDistanceGliding: 'travelDistanceGliding',
  travelDistanceGlidingUnit: 'travelDistanceGlidingUnit',
  verticalAllowed: 'verticalAllowed',
  speedMaxVertical: 'speedMaxVertical',
  speedMaxVerticalUnit: 'speedMaxVerticalUnit',
  accelerationMaxVertical: 'accelerationMaxVertical',
  accelerationMaxVerticalUnit: 'accelerationMaxVerticalUnit',
  travelDistanceVertical: 'travelDistanceVertical',
  travelDistanceVerticalUnit: 'travelDistanceVerticalUnit',
  oilResistant: 'oilResistant',
  outerJacket: 'outerJacket'
};

exports.Prisma.ChainflexScalarFieldEnum = {
  akeneoSku: 'akeneoSku',
  akeneoUuid: 'akeneoUuid',
  dataSource: 'dataSource',
  discontinuedModel: 'discontinuedModel',
  echainId: 'echainId',
  serieRefId: 'serieRefId',
  categories: 'categories',
  ecfAllowed: 'ecfAllowed',
  eicAllowed: 'eicAllowed',
  eiqAllowed: 'eiqAllowed',
  ekeAllowed: 'ekeAllowed',
  artNr: 'artNr',
  articleSpecs: 'articleSpecs',
  articleType: 'articleType',
  chainBendRadiusMin: 'chainBendRadiusMin',
  chainBendRadiusMinUnit: 'chainBendRadiusMinUnit',
  copperWeight: 'copperWeight',
  copperWeightUnit: 'copperWeightUnit',
  crossSection: 'crossSection',
  nominalCrossSection: 'nominalCrossSection',
  numberOfCores: 'numberOfCores',
  numberOfCoresCalculated: 'numberOfCoresCalculated',
  outerDiameter: 'outerDiameter',
  outerDiameterUnit: 'outerDiameterUnit',
  ralnumber: 'ralnumber',
  weight: 'weight',
  weightUnit: 'weightUnit',
  busSystem: 'busSystem',
  cleanRoom: 'cleanRoom',
  coolantResistant: 'coolantResistant',
  desina: 'desina',
  dnvGL: 'dnvGL',
  eac: 'eac',
  flameRetardant: 'flameRetardant',
  halogenFree: 'halogenFree',
  mudResistant: 'mudResistant',
  overallShielding: 'overallShielding',
  shielding: 'shielding',
  torsionAngle: 'torsionAngle',
  torsionAngleUnit: 'torsionAngleUnit',
  torsionable: 'torsionable',
  twistedPair: 'twistedPair',
  ulCsa: 'ulCsa',
  unshielded: 'unshielded',
  uvResistant: 'uvResistant',
  temperatureMax: 'temperatureMax',
  temperatureMaxUnit: 'temperatureMaxUnit',
  temperatureMin: 'temperatureMin',
  temperatureMinUnit: 'temperatureMinUnit'
};

exports.Prisma.ReadycableScalarFieldEnum = {
  akeneoSku: 'akeneoSku',
  akeneoUuid: 'akeneoUuid',
  dataSource: 'dataSource',
  discontinuedModel: 'discontinuedModel',
  echainId: 'echainId',
  chainflexRef: 'chainflexRef',
  categories: 'categories',
  mainCategory: 'mainCategory',
  ecfAllowed: 'ecfAllowed',
  eicAllowed: 'eicAllowed',
  eiqAllowed: 'eiqAllowed',
  ekeAllowed: 'ekeAllowed',
  artNr: 'artNr',
  articleSpecs: 'articleSpecs',
  articleType: 'articleType',
  chainBendRadiusMin: 'chainBendRadiusMin',
  chainBendRadiusMinUnit: 'chainBendRadiusMinUnit',
  copperWeight: 'copperWeight',
  copperWeightUnit: 'copperWeightUnit',
  crossSection: 'crossSection',
  description: 'description',
  nominalCrossSection: 'nominalCrossSection',
  numberOfCores: 'numberOfCores',
  numberOfCoresCalculated: 'numberOfCoresCalculated',
  outerDiameter: 'outerDiameter',
  outerDiameterUnit: 'outerDiameterUnit',
  outerJacket: 'outerJacket',
  ralnumber: 'ralnumber',
  temperatureMax: 'temperatureMax',
  temperatureMaxUnit: 'temperatureMaxUnit',
  temperatureMin: 'temperatureMin',
  temperatureMinUnit: 'temperatureMinUnit',
  weight: 'weight',
  weightUnit: 'weightUnit',
  unsupportedAllowed: 'unsupportedAllowed',
  speedMaxUnsupported: 'speedMaxUnsupported',
  speedMaxUnsupportedUnit: 'speedMaxUnsupportedUnit',
  accelerationMaxUnsupported: 'accelerationMaxUnsupported',
  accelerationMaxUnsupportedUnit: 'accelerationMaxUnsupportedUnit',
  travelDistanceUnsupported: 'travelDistanceUnsupported',
  travelDistanceUnsupportedUnit: 'travelDistanceUnsupportedUnit',
  glidingAllowed: 'glidingAllowed',
  speedMaxGliding: 'speedMaxGliding',
  speedMaxGlidingUnit: 'speedMaxGlidingUnit',
  accelerationMaxGliding: 'accelerationMaxGliding',
  accelerationMaxGlidingUnit: 'accelerationMaxGlidingUnit',
  travelDistanceGliding: 'travelDistanceGliding',
  travelDistanceGlidingUnit: 'travelDistanceGlidingUnit',
  verticalAllowed: 'verticalAllowed',
  speedMaxVertical: 'speedMaxVertical',
  speedMaxVerticalUnit: 'speedMaxVerticalUnit',
  accelerationMaxVertical: 'accelerationMaxVertical',
  accelerationMaxVerticalUnit: 'accelerationMaxVerticalUnit',
  travelDistanceVertical: 'travelDistanceVertical',
  travelDistanceVerticalUnit: 'travelDistanceVerticalUnit',
  fixedLength: 'fixedLength',
  cableLength: 'cableLength',
  cableLengthUnit: 'cableLengthUnit',
  hasConnector: 'hasConnector',
  connector1: 'connector1',
  connector2: 'connector2',
  openEnd: 'openEnd',
  subCategory: 'subCategory',
  manufacturer: 'manufacturer',
  manufacturerPartNo: 'manufacturerPartNo'
};

exports.Prisma.PullWireScalarFieldEnum = {
  akeneoSku: 'akeneoSku',
  akeneoUuid: 'akeneoUuid',
  dataSource: 'dataSource',
  discontinuedModel: 'discontinuedModel',
  echainId: 'echainId',
  categories: 'categories',
  ecfAllowed: 'ecfAllowed',
  eicAllowed: 'eicAllowed',
  eiqAllowed: 'eiqAllowed',
  ekeAllowed: 'ekeAllowed',
  artNr: 'artNr',
  articleSpecs: 'articleSpecs',
  articleType: 'articleType',
  chainBendRadiusMin: 'chainBendRadiusMin',
  chainBendRadiusMinUnit: 'chainBendRadiusMinUnit',
  crossSection: 'crossSection',
  description: 'description',
  numberOfCores: 'numberOfCores',
  mainCategory: 'mainCategory',
  outerDiameter: 'outerDiameter',
  outerDiameterUnit: 'outerDiameterUnit',
  outerJacket: 'outerJacket',
  ralnumber: 'ralnumber',
  weight: 'weight',
  weightUnit: 'weightUnit'
};

exports.Prisma.LeitungPrismaScalarFieldEnum = {
  AkeneoSku: 'AkeneoSku',
  AkeneoUuid: 'AkeneoUuid',
  DataSource: 'DataSource',
  DiscontinuedModel: 'DiscontinuedModel',
  EchainId: 'EchainId',
  ChainflexRef: 'ChainflexRef',
  FreigabeECF: 'FreigabeECF',
  FreigabeEIC: 'FreigabeEIC',
  FreigabeEIQ: 'FreigabeEIQ',
  FreigabeEKE: 'FreigabeEKE',
  Aderzahl: 'Aderzahl',
  AderzahlBerechnet: 'AderzahlBerechnet',
  ArtNr: 'ArtNr',
  ArticleSpecs: 'ArticleSpecs',
  ArticleType: 'ArticleType',
  Aussendurchmesser: 'Aussendurchmesser',
  Bezeichnung: 'Bezeichnung',
  BiegeradiusMin: 'BiegeradiusMin',
  GewichtKgProKm: 'GewichtKgProKm',
  Kupferzahl: 'Kupferzahl',
  Leitungsaufbau: 'Leitungsaufbau',
  Querschnitt: 'Querschnitt',
  RAL_Nummer: 'RAL_Nummer',
  Categories: 'Categories',
  MainCategory: 'MainCategory',
  FreitragenderBetriebErlaubt: 'FreitragenderBetriebErlaubt',
  AuhiFreitragendA: 'AuhiFreitragendA',
  AuhiFreitragendV: 'AuhiFreitragendV',
  VerfahrwegFreitragendMax: 'VerfahrwegFreitragendMax',
  AuhiGleitend: 'AuhiGleitend',
  AuhiGleitendA: 'AuhiGleitendA',
  AuhiGleitendV: 'AuhiGleitendV',
  VerfahrwegGleitendMax: 'VerfahrwegGleitendMax',
  HaengenderBetriebErlaubt: 'HaengenderBetriebErlaubt',
  BeschleunigungHaengendMax: 'BeschleunigungHaengendMax',
  GeschwindigkeitHaengendMax: 'GeschwindigkeitHaengendMax',
  VerfahrwegHaengendMax: 'VerfahrwegHaengendMax',
  AuhiTemperaturMax: 'AuhiTemperaturMax',
  AuhiTemperaturMin: 'AuhiTemperaturMin',
  BusSystem: 'BusSystem',
  DESINA: 'DESINA',
  DNV_GL: 'DNV_GL',
  EAC: 'EAC',
  Flammwidrig: 'Flammwidrig',
  Gesamtschirm: 'Gesamtschirm',
  Halogenfrei: 'Halogenfrei',
  Kuehlmittelbestaendig: 'Kuehlmittelbestaendig',
  MUDBestaendig: 'MUDBestaendig',
  Mantelwerkstoff: 'Mantelwerkstoff',
  Oelbestaendigkeit: 'Oelbestaendigkeit',
  Reinraum: 'Reinraum',
  Schirmung: 'Schirmung',
  Torsionsfaehig: 'Torsionsfaehig',
  Torsionswinkel: 'Torsionswinkel',
  TwistedPair: 'TwistedPair',
  UL_CSA: 'UL_CSA',
  UVBestaendigkeit: 'UVBestaendigkeit',
  Ungeschirmt: 'Ungeschirmt',
  FesteLaenge: 'FesteLaenge',
  Leitungslaenge: 'Leitungslaenge',
  HatStecker: 'HatStecker',
  Stecker1: 'Stecker1',
  Stecker2: 'Stecker2',
  OpenEnd: 'OpenEnd',
  SubCategory: 'SubCategory',
  Manufacturer: 'Manufacturer',
  ManufacturerPartNo: 'ManufacturerPartNo'
};

exports.Prisma.SmartPlasticsPartScalarFieldEnum = {
  akeneoSku: 'akeneoSku',
  akeneoUuid: 'akeneoUuid',
  dataSource: 'dataSource',
  discontinuedModel: 'discontinuedModel',
  echainId: 'echainId',
  artNr: 'artNr',
  articleSpecs: 'articleSpecs',
  articleType: 'articleType',
  description: 'description',
  weight: 'weight',
  weightUnit: 'weightUnit',
  smartPlasticsCableId: 'smartPlasticsCableId',
  smartPlasticsType: 'smartPlasticsType',
  smartPlasticsParentEchainId: 'smartPlasticsParentEchainId',
  partsReferences: 'partsReferences',
  ecfAllowed: 'ecfAllowed',
  eicAllowed: 'eicAllowed',
  eiqAllowed: 'eiqAllowed',
  ekeAllowed: 'ekeAllowed'
};

exports.Prisma.SmartPlasticsPartPrismaScalarFieldEnum = {
  AkeneoSku: 'AkeneoSku',
  AkeneoUuid: 'AkeneoUuid',
  DataSource: 'DataSource',
  DiscontinuedModel: 'DiscontinuedModel',
  EchainId: 'EchainId',
  ArtNr: 'ArtNr',
  ArticleSpecs: 'ArticleSpecs',
  ArticleType: 'ArticleType',
  Bezeichnung: 'Bezeichnung',
  weight: 'weight',
  smartPlasticsType: 'smartPlasticsType',
  partsReferences: 'partsReferences',
  smartPlasticsCableId: 'smartPlasticsCableId',
  smartPlasticsParentEchainId: 'smartPlasticsParentEchainId',
  FreigabeECF: 'FreigabeECF',
  FreigabeEIC: 'FreigabeEIC',
  FreigabeEIQ: 'FreigabeEIQ',
  FreigabeEKE: 'FreigabeEKE'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.DataSource = {
  akeneo: 'akeneo',
  ipro: 'ipro',
  stub: 'stub',
  mix: 'mix'
};

exports.ChainflexCategory = {
  ControlCables: 'ControlCables',
  DataCables: 'DataCables',
  MotorCables: 'MotorCables',
  ServoCables: 'ServoCables',
  PneumaticHoses: 'PneumaticHoses',
  CoaxCables: 'CoaxCables',
  FibreOpticCables: 'FibreOpticCables',
  MeasuringSystemCables: 'MeasuringSystemCables',
  BusCables: 'BusCables',
  RobotCables: 'RobotCables',
  SpecialCables: 'SpecialCables',
  HydraulicCables: 'HydraulicCables',
  HybridCables: 'HybridCables',
  PullWires: 'PullWires'
};

exports.VelocityUnit = {
  km_h: 'km_h',
  m_s: 'm_s',
  fpm: 'fpm',
  ft_s: 'ft_s'
};

exports.AccelerationUnit = {
  m_s2: 'm_s2',
  ft_s2: 'ft_s2'
};

exports.LengthUnit = {
  km: 'km',
  m: 'm',
  cm: 'cm',
  mm: 'mm',
  um: 'um',
  mil: 'mil',
  inch: 'inch',
  ft: 'ft'
};

exports.ArticleType = {
  leitung: 'leitung',
  link: 'link',
  kette: 'kette',
  ae: 'ae',
  ia: 'ia',
  zugentlastung: 'zugentlastung',
  verpackung: 'verpackung',
  konfektionierung: 'konfektionierung',
  fuehrungsrinne: 'fuehrungsrinne',
  montageSet: 'montageSet',
  montBes: 'montBes',
  espool: 'espool',
  zubehoer: 'zubehoer'
};

exports.WeightPerLengthUnit = {
  kg_km: 'kg_km',
  kg_m: 'kg_m',
  g_m: 'g_m',
  lbs_mft: 'lbs_mft',
  lbs_ft: 'lbs_ft'
};

exports.AnglePerLengthUnit = {
  deg_m: 'deg_m'
};

exports.TemperatureUnit = {
  celsius: 'celsius',
  F: 'F',
  K: 'K'
};

exports.ArticleSpec = {
  espoolOnly: 'espoolOnly',
  espoolReady: 'espoolReady',
  Chainflex: 'Chainflex',
  Readycable: 'Readycable',
  PullWire: 'PullWire',
  erkReady: 'erkReady',
  SmartPlasticsOnly: 'SmartPlasticsOnly',
  SmartPlasticsECPSensor: 'SmartPlasticsECPSensor',
  SmartPlasticsECPDummy: 'SmartPlasticsECPDummy',
  SmartPlasticsModule: 'SmartPlasticsModule',
  SmartPlasticsSMSModule: 'SmartPlasticsSMSModule',
  SmartPlasticsSimCard: 'SmartPlasticsSimCard'
};

exports.ReadycableCategory = {
  DriveTech: 'DriveTech',
  NetTech: 'NetTech',
  SensorActor: 'SensorActor',
  VideoVisionBus: 'VideoVisionBus',
  HartingIndustrialConnectors: 'HartingIndustrialConnectors',
  RcRobotic: 'RcRobotic'
};

exports.ReadycableSubCategory = {
  NetTechDeviceNet: 'NetTechDeviceNet',
  NetTechEthernet: 'NetTechEthernet',
  NetTechFoc: 'NetTechFoc',
  NetTechProfibus: 'NetTechProfibus',
  NetTechProfinet: 'NetTechProfinet',
  VideoVisionBusFireWire: 'VideoVisionBusFireWire',
  VideoVisionBusUsb2_0: 'VideoVisionBusUsb2_0',
  VideoVisionBusUsb3_0: 'VideoVisionBusUsb3_0',
  VideoVisionBusGigE: 'VideoVisionBusGigE',
  VideoVisionBusDviD_Hdmi: 'VideoVisionBusDviD_Hdmi',
  VideoVisionBusCoax: 'VideoVisionBusCoax',
  VideoVisionBusVga: 'VideoVisionBusVga',
  SensorActorCf9_CfIni: 'SensorActorCf9_CfIni',
  SensorActorCf10_CfIni: 'SensorActorCf10_CfIni',
  SensorActorCf98_CfIni: 'SensorActorCf98_CfIni',
  SensorActorConnectionCables: 'SensorActorConnectionCables',
  HartingHan6b: 'HartingHan6b',
  HartingHan10b: 'HartingHan10b',
  HartingHan16b: 'HartingHan16b',
  HartingHan24b: 'HartingHan24b',
  RcRoboticKuka: 'RcRoboticKuka',
  RcRoboticFanuc: 'RcRoboticFanuc',
  RcRoboticAbb: 'RcRoboticAbb',
  RcRoboticAida: 'RcRoboticAida'
};

exports.WeightUnit = {
  kg: 'kg',
  g: 'g',
  lbs: 'lbs'
};

exports.SmartPlasticsType = {
  ECP: 'ECP'
};

exports.Prisma.ModelName = {
  ChainflexSeries: 'ChainflexSeries',
  Chainflex: 'Chainflex',
  Readycable: 'Readycable',
  PullWire: 'PullWire',
  LeitungPrisma: 'LeitungPrisma',
  SmartPlasticsPart: 'SmartPlasticsPart',
  SmartPlasticsPartPrisma: 'SmartPlasticsPartPrisma'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
